import type { ReactNode } from "react";
import { PencilIcon } from "@/components/ui/Icons";

type Props = {
  title: string;
  icon?: ReactNode;
  editLabel: string;
  onEdit: () => void;
  children: ReactNode;
};

export function SummarySection({ title, icon, editLabel, onEdit, children }: Props) {
  return (
    <section className="bk-summary-section">
      <div className="bk-summary-section__head">
        <h3 className="bk-summary-section__title">
          {icon}
          <span>{title}</span>
        </h3>
        <button
          type="button"
          className="inline-flex shrink-0 items-center gap-1 rounded-md px-2 py-1 text-xs font-semibold text-brand-700 transition hover:bg-brand-50 focus:outline-none focus:ring-2 focus:ring-brand-500/40"
          onClick={onEdit}
          aria-label={`${title} ${editLabel}`}
        >
          <PencilIcon className="h-3.5 w-3.5" />
          <span>{editLabel}</span>
        </button>
      </div>
      {children}
    </section>
  );
}

export function SummaryRows({ rows }: { rows: { label: string; value: ReactNode }[] }) {
  const visible = rows.filter((row) => row.value !== null && row.value !== undefined && row.value !== "");
  if (visible.length === 0) return null;
  return (
    <dl className="bk-summary-grid">
      {visible.map((row) => (
        <div key={row.label} className="contents">
          <dt>{row.label}</dt>
          <dd>{row.value}</dd>
        </div>
      ))}
    </dl>
  );
}
